<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <div
        data-slot="card-footer"
        :class="cn('flex items-center justify-center px-5 pb-5 [.border-t]:pt-5', props.class)"
    >
        <slot />
    </div>
</template>
